import { Pagination } from 'react-admin';
const OwnPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export default OwnPagination;